module.exports = !require('./_descriptors') && !require('./_fails')(function(){
  return Object.defineProperty(require('./_dom-create')('div'), 'a', {get: function(){ return 7; }}).a != 7;
});


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/jszip/node_modules/core-js/library/modules/_ie8-dom-define.js
// module id = ../../../../jszip/node_modules/core-js/library/modules/_ie8-dom-define.js
// module chunks = common